import { ClaudeTemplate } from "../types";
import { BASE, ENTER_ACCOUNT } from "./googleAdsShared";

/** Google Ads Search (SEM). */
export const googleAdsSearchTemplate: ClaudeTemplate = {
  ...BASE,
  id: "google-ads-search",
  hierarchy:
    "Cuenta (MCC) → Customer account → Campaign (Search) → Ad groups → Keywords + Responsive search ads",
  steps: `${ENTER_ACCOUNT}
### 2. Campaign de búsqueda
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, "New campaign":
   - Objective: el que encaje con {{goal.kpi}} (CPC → Website traffic; CPA/CPL → Sales o Leads), o "Create a campaign without guidance" si encaja mejor.
   - Campaign type: **Search**.
   - Campaign name: {{names.order}}
   - Networks: solo Google Search (desactiva Search partners y Display Network, salvo que las notas digan otra cosa).
   - Locations: {{target.geography}} (país {{goal.country}}), con "Presence: people in or regularly in". Languages: {{target.language}}.
   - Budget: Google Ads trabaja con presupuesto **diario**. Calcula {{goal.budget}} / número de días entre {{goal.startDate}} y {{goal.endDate}}, redondea a la baja y dime el cálculo. Si la cuenta permite "campaign total budget", úsalo con {{goal.budget}}.
   - Bidding: Maximize clicks con CPC máximo en torno a {{goal.netUnitCost}} (si el objetivo es CPC), o Maximize conversions / Target CPA (si es CPA/CPL y hay conversiones configuradas). Si dudas, pregunta.
   - Start / end date: {{goal.startDate}} → {{goal.endDate}}.
   - Audiencias en modo "Observation": {{target.audience}}.

### 3. Ad groups y keywords
1. Crea un ad group con nombre {{names.line}}.
2. Keywords: las que vengan en el briefing (notas, intereses o enlaces extra: {{target.interests}}). **Si el briefing no trae keywords, para y pregúntame**: no las inventes.
3. Negative keywords: {{target.exclusions}}.

### 4. Anuncios
1. Responsive search ad: final URL con UTM del bloque "URLs de destino"; titulares y descripciones del bloque "Copies". Si no hay suficientes titulares (mínimo 3) o descripciones (mínimo 2), pregunta.
2. Assets (sitelinks, callouts…): solo los que vengan en el briefing.
3. Al terminar, **pausa la campaña** (Google Ads la crea activa por defecto: cámbiala a "Paused" antes de publicar o justo después, y avísame).
`,
};
